import Logo from '../../src/Gif/1739196168277Fusion Logo.png'
export const GOOGLE_API_KEY = "AIzaSyB0VFLrPEaYGqP4FVdGDEeUUN6Ks9AZPao"; 
export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1Ijoic2lnbndpc2UiLCJhIjoiY21jOWIzbHZqMDB4YjJrc2xma2poaWthaSJ9.IBp9oEABcju66Oj2awW0QA';
export const defaultZipCode = '85122'; 
export const ChatGifApiKey = 'AIzaSyBFaHxqfZL4xpwtA5WnSqXmrUvCvJ2bFzc'
export const SEND_EMAIL = false

// export const GOOGLE_API_KEY = "AIzaSyBe6vrykAsiKjwIHWOUcfH1Li4VT-2LHTg";
const user =  JSON.parse(localStorage.getItem('user'))

// export const REST_API_END_POINT = "http://localhost:4000/webservice/";
// export const REST_API = "http://localhost:4000/";
// export const REST_API_IO = "https://socket.signwisesolutions.com";
// // Socket IO disabled to stop console WebSocket errors when socket.signwisesolutions.com is down.
// // To re-enable later: set ENABLE_SOCKET_IO = true (or uncomment the old `io(REST_API_IO, ...)` code kept in each file).
// export const ENABLE_SOCKET_IO = false;
// // OLD: direct socket URL (kept for restore) — used with: io(REST_API_IO, { path: "/socket.io", transports: ["websocket", "polling"], secure: true })
// export const BASE_URL = "http://localhost:4000/"
// export const BASE_URL_QR = "http://localhost:3000"
// export const DOMAIN = 'localhost'
// export const COMPANY_NAME = user?.company_name || 'Signwise Solutions Arizona'
// export const currentFacilityId = 1
// export const QBShow = false;
// export const ENABLE_NEW_RELIC = false;
// export const FacilityTypes = [ // make true for current facility
//   { id: 1, label: 'Arizona', code: 'AZ',default:true,color:"primary" },
//   { id: 2, label: 'Riverside', code: 'RIV',default:false,color:"warning" },
//   { id: 3, label: 'LA', code: 'LA',default:false,color:"success" },
//   // { id: 4, label: 'Dev', code: 'DEV',default:true,color:"success" },
//   // { id: 5, label: 'Training', code: 'TRAINING',default:true,color:"error" },
// ]


//PRODUCTION
export const VERSION = '8.68'; // change the manifest.json page name to facility name

//DEV
// export const VERSION = '7.12';

// arizona.signwisesolutions.com
// export const BASE_URL = "https://az.signwise3s.com/"
// export const REST_API_END_POINT = "https://az.signwise3s.com/backend/webservice/";
// export const REST_API = "https://az.signwise3s.com/backend/";
// export const REST_API_IO = "https://socket.signwise3s.com";
// export const BASE_URL_QR = "https://az.signwise3s.com"
// export const DOMAIN = 'arizona';
// // Socket IO disabled to stop console WebSocket errors when socket.signwisesolutions.com is down.
// // To re-enable later: set ENABLE_SOCKET_IO = true (or uncomment the old `io(REST_API_IO, ...)` code kept in each file).
// export const ENABLE_SOCKET_IO = false;
// export const QBShow = false;
// export const ENABLE_NEW_RELIC = false;
// export const COMPANY_NAME = user?.company_name || 'Signwise Solutions Arizona'
// export const currentFacilityId = 1
// export const FacilityTypes = [ // make true for current facility
//   { id: 1, label: 'Arizona', code: 'AZ',default:true,color:"primary" },
//   { id: 2, label: 'Riverside', code: 'RIV',default:false,color:"warning" },
//   { id: 3, label: 'LA', code: 'LA',default:false,color:"success" },
//   // { id: 4, label: 'Dev', code: 'DEV',default:true,color:"success" },
//   // { id: 5, label: 'Training', code: 'TRAINING',default:true,color:"error" },
//   { id: 6, label: 'NCA', code: 'NCA',default:false,color:"error" },
//   { id: 7, label: 'LV', code: 'LV',default:false,color:"info" },
//   { id: 8, label: 'DEN', code: 'DEN',default:false,color:"secondary" },
//   { id: 9, label: 'COS', code: 'COS',default:false,color:"primary" },
//   { id: 10, label: 'OK', code: 'OK',default:false,color:"success" },
// ]

// dev.signwisesolutions.com
// export const BASE_URL = "https://dev.signwisesolutions.com/"
// export const REST_API_END_POINT = "https://dev.signwisesolutions.com/backend/webservice/";
// export const REST_API = "https://dev.signwisesolutions.com/backend/";
// export const REST_API_IO = "https://socket.signwisesolutions.com";
// export const BASE_URL_QR = "https://dev.signwisesolutions.com"
// export const DOMAIN = 'dev';
// export const QBShow = false;
// export const ENABLE_NEW_RELIC = false;
// // Socket IO disabled to stop console WebSocket errors when socket.signwisesolutions.com is down.
// // To re-enable later: set ENABLE_SOCKET_IO = true (or uncomment the old `io(REST_API_IO, ...)` code kept in each file).
// export const ENABLE_SOCKET_IO = false;
// export const COMPANY_NAME = user?.company_name || 'Signwise Solutions Dev'
// export const currentFacilityId = 4
// export const FacilityTypes = [ // make true for current facility
//   { id: 1, label: 'Arizona', code: 'AZ',default:false,color:"primary" },
//   { id: 2, label: 'Riverside', code: 'RIV',default:false,color:"warning" },
//   { id: 3, label: 'LA', code: 'LA',default:false,color:"success" },
//   { id: 4, label: 'Dev', code: 'DEV',default:true,color:"success" },
//   // { id: 5, label: 'Training', code: 'TRAINING',default:true,color:"error" },
// ]

// riverside.signwisesolutions.com/
// export const BASE_URL = "https://riv.signwise3s.com/"
// export const REST_API_END_POINT = "https://riv.signwise3s.com/backend/webservice/";
// export const REST_API = "https://riv.signwise3s.com/backend/";
// export const REST_API_IO = "https://socket.signwise3s.com";
// export const BASE_URL_QR = "https://riv.signwise3s.com"
// export const DOMAIN = 'riv';
// export const QBShow = false;
// export const ENABLE_NEW_RELIC = false;
// // Socket IO disabled to stop console WebSocket errors when socket.signwisesolutions.com is down.
// // To re-enable later: set ENABLE_SOCKET_IO = true (or uncomment the old `io(REST_API_IO, ...)` code kept in each file).
// export const ENABLE_SOCKET_IO = false;
// export const COMPANY_NAME = user?.company_name || 'Signwise Solutions Riverside'
// export const currentFacilityId = 2
// export const FacilityTypes = [ // make true for current facility
//   { id: 1, label: 'Arizona', code: 'AZ',default:false,color:"primary" },
//   { id: 2, label: 'Riverside', code: 'RIV',default:true,color:"warning" },
//   { id: 3, label: 'LA', code: 'LA',default:false,color:"success" },
//   // { id: 4, label: 'Dev', code: 'DEV',default:true,color:"success" },
//   // { id: 5, label: 'Training', code: 'TRAINING',default:true,color:"error" },
//   { id: 6, label: 'NCA', code: 'NCA',default:false,color:"error" },
//  { id: 7, label: 'LV', code: 'LV',default:false,color:"info" },
//   { id: 8, label: 'DEN', code: 'DEN',default:false,color:"secondary" },
//   { id: 9, label: 'COS', code: 'COS',default:false,color:"primary" },
//   { id: 10, label: 'OK', code: 'OK',default:false,color:"success" },
// ]

//la.signwisesolutions.com/
// export const BASE_URL = "https://la.signwise3s.com/"
// export const REST_API_END_POINT = "https://la.signwise3s.com/backend/webservice/";
// export const REST_API = "https://la.signwise3s.com/backend/";
// export const REST_API_IO = "https://socket.signwise3s.com";
// export const BASE_URL_QR = "https://la.signwise3s.com"
// export const DOMAIN = 'la';
// export const QBShow = false;
// export const ENABLE_NEW_RELIC = false;
// // Socket IO disabled to stop console WebSocket errors when socket.signwisesolutions.com is down.
// // To re-enable later: set ENABLE_SOCKET_IO = true (or uncomment the old `io(REST_API_IO, ...)` code kept in each file).
// export const ENABLE_SOCKET_IO = false;
// export const COMPANY_NAME = user?.company_name || 'Signwise Solutions LA'
// export const currentFacilityId = 3
// export const FacilityTypes = [ // make true for current facility
//   { id: 1, label: 'Arizona', code: 'AZ',default:false,color:"primary" },
//   { id: 2, label: 'Riverside', code: 'RIV',default:false,color:"warning" },
//   { id: 3, label: 'LA', code: 'LA',default:true,color:"success" },
//   // { id: 4, label: 'Dev', code: 'DEV',default:true,color:"success" },
//   // { id: 5, label: 'Training', code: 'TRAINING',default:true,color:"error" },
//   { id: 6, label: 'NCA', code: 'NCA',default:false,color:"error" },
//  { id: 7, label: 'LV', code: 'LV',default:false,color:"info" },
//   { id: 8, label: 'DEN', code: 'DEN',default:false,color:"secondary" },
//   { id: 9, label: 'COS', code: 'COS',default:false,color:"primary" },
//   { id: 10, label: 'OK', code: 'OK',default:false,color:"success" },
// ]

// nca.signwisesolutions.com
// export const BASE_URL = "https://nca.signwise3s.com/"
// export const REST_API_END_POINT = "https://nca.signwise3s.com/backend/webservice/";
// export const REST_API = "https://nca.signwise3s.com/backend/";
// export const REST_API_IO = "https://socket.signwise3s.com";
// export const BASE_URL_QR = "https://nca.signwise3s.com"
// export const DOMAIN = 'nca';
// export const QBShow = false;
// export const ENABLE_NEW_RELIC = false;
// // Socket IO disabled to stop console WebSocket errors when socket.signwisesolutions.com is down.
// // To re-enable later: set ENABLE_SOCKET_IO = true (or uncomment the old `io(REST_API_IO, ...)` code kept in each file).
// export const ENABLE_SOCKET_IO = false;
// export const COMPANY_NAME = user?.company_name || 'Signwise Solutions NCA'
// export const currentFacilityId = 6
// export const FacilityTypes = [ // make true for current facility
//   { id: 1, label: 'Arizona', code: 'AZ',default:false,color:"primary" },
//   { id: 2, label: 'Riverside', code: 'RIV',default:false,color:"warning" },
//   { id: 3, label: 'LA', code: 'LA',default:false,color:"success" },
//   // { id: 4, label: 'Dev', code: 'DEV',default:true,color:"success" },
//   // { id: 5, label: 'Training', code: 'TRAINING',default:true,color:"error" },
//   { id: 6, label: 'NCA', code: 'NCA',default:true,color:"error" },
//  { id: 7, label: 'LV', code: 'LV',default:false,color:"info" },
//   { id: 8, label: 'DEN', code: 'DEN',default:false,color:"secondary" },
//   { id: 9, label: 'COS', code: 'COS',default:false,color:"primary" },
//   { id: 10, label: 'OK', code: 'OK',default:false,color:"success" },
// ]

// lv.signwisesolutions.com
// export const BASE_URL = "https://lv.signwise3s.com/"
// export const REST_API_END_POINT = "https://lv.signwise3s.com/backend/webservice/";
// export const REST_API = "https://lv.signwise3s.com/backend/";
// export const REST_API_IO = "https://socket.signwise3s.com";
// export const BASE_URL_QR = "https://lv.signwise3s.com"
// export const DOMAIN = 'lv';
// export const QBShow = false;
// export const ENABLE_NEW_RELIC = false;
// // Socket IO disabled to stop console WebSocket errors when socket.signwisesolutions.com is down.
// // To re-enable later: set ENABLE_SOCKET_IO = true (or uncomment the old `io(REST_API_IO, ...)` code kept in each file).
// export const ENABLE_SOCKET_IO = false;
// export const COMPANY_NAME = user?.company_name || 'Signwise Solutions LV'
// export const currentFacilityId = 7
// export const FacilityTypes = [ // make true for current facility
//   { id: 1, label: 'Arizona', code: 'AZ',default:false,color:"primary" },
//   { id: 2, label: 'Riverside', code: 'RIV',default:false,color:"warning" },
//   { id: 3, label: 'LA', code: 'LA',default:false,color:"success" },
//   // { id: 4, label: 'Dev', code: 'DEV',default:true,color:"success" },
//   // { id: 5, label: 'Training', code: 'TRAINING',default:true,color:"error" },
//   { id: 6, label: 'NCA', code: 'NCA',default:false,color:"error" },
//   { id: 7, label: 'LV', code: 'LV',default:true,color:"info" },
//   { id: 8, label: 'DEN', code: 'DEN',default:false,color:"secondary" },
//   { id: 9, label: 'COS', code: 'COS',default:false,color:"primary" },
//   { id: 10, label: 'OK', code: 'OK',default:false,color:"success" },
// ]

// den.signwisesolutions.com/
// export const BASE_URL = "https://den.signwise3s.com/"
// export const REST_API_END_POINT = "https://den.signwise3s.com/backend/webservice/";
// export const REST_API = "https://den.signwise3s.com/backend/";
// export const REST_API_IO = "https://socket.signwise3s.com";
// export const BASE_URL_QR = "https://den.signwise3s.com"
// export const DOMAIN = 'den';
// export const QBShow = false;
// export const ENABLE_NEW_RELIC = false;
// // Socket IO disabled to stop console WebSocket errors when socket.signwisesolutions.com is down.
// // To re-enable later: set ENABLE_SOCKET_IO = true (or uncomment the old `io(REST_API_IO, ...)` code kept in each file).
// export const ENABLE_SOCKET_IO = false;
// export const COMPANY_NAME = user?.company_name || 'Signwise Solutions Denver'
// export const currentFacilityId = 8
// export const FacilityTypes = [ // make true for current facility
//   { id: 1, label: 'Arizona', code: 'AZ',default:false,color:"primary" },
//   { id: 2, label: 'Riverside', code: 'RIV',default:false,color:"warning" },
//   { id: 3, label: 'LA', code: 'LA',default:false,color:"success" },
//   // { id: 4, label: 'Dev', code: 'DEV',default:true,color:"success" },
//   // { id: 5, label: 'Training', code: 'TRAINING',default:true,color:"error" },
//   { id: 6, label: 'NCA', code: 'NCA',default:false,color:"error" },
//   { id: 7, label: 'LV', code: 'LV',default:false,color:"info" },
//   { id: 8, label: 'DEN', code: 'DEN',default:true,color:"secondary" },
//   { id: 9, label: 'COS', code: 'COS',default:false,color:"primary" },
//   { id: 10, label: 'OK', code: 'OK',default:false,color:"success" },
// ]

//cos.signwisesolutions.com/
export const BASE_URL = "https://cos.signwise3s.com/"
export const REST_API_END_POINT = "https://cos.signwise3s.com/backend/webservice/";
export const REST_API = "https://cos.signwise3s.com/backend/";
export const REST_API_IO = "https://socket.signwise3s.com";
export const BASE_URL_QR = "https://cos.signwise3s.com"
export const DOMAIN = 'cos';
export const QBShow = false;
export const ENABLE_NEW_RELIC = false;
// Socket IO disabled to stop console WebSocket errors when socket.signwisesolutions.com is down.
// To re-enable later: set ENABLE_SOCKET_IO = true (or uncomment the old `io(REST_API_IO, ...)` code kept in each file).
export const ENABLE_SOCKET_IO = false;
export const COMPANY_NAME = user?.company_name || 'Signwise Solutions Cosprings'
export const currentFacilityId = 9
export const FacilityTypes = [ // make true for current facility
  { id: 1, label: 'Arizona', code: 'AZ',default:false,color:"primary" },
  { id: 2, label: 'Riverside', code: 'RIV',default:false,color:"warning" },
  { id: 3, label: 'LA', code: 'LA',default:false,color:"success" },
  // { id: 4, label: 'Dev', code: 'DEV',default:true,color:"success" },
  // { id: 5, label: 'Training', code: 'TRAINING',default:true,color:"error" },
  { id: 6, label: 'NCA', code: 'NCA',default:false,color:"error" },
  { id: 7, label: 'LV', code: 'LV',default:false,color:"info" },
  { id: 8, label: 'DEN', code: 'DEN',default:false,color:"secondary" },
  { id: 9, label: 'COS', code: 'COS',default:true,color:"primary" },
  { id: 10, label: 'OK', code: 'OK',default:false,color:"success" },
]

// dev-riv.signwisesolutions.com
// export const BASE_URL = "https://dev-riv.signwisesolutions.com/"
// export const REST_API_END_POINT = "https://dev-riv.signwisesolutions.com/backend/webservice/";
// export const REST_API = "https://dev-riv.signwisesolutions.com/backend/";
// export const REST_API_IO = "https://socket.signwisesolutions.com";
// export const BASE_URL_QR = "https://dev-riv.signwisesolutions.com"
// export const DOMAIN = 'dev-riv';
// export const QBShow = false;
// export const ENABLE_NEW_RELIC = false;
// // Socket IO disabled to stop console WebSocket errors when socket.signwisesolutions.com is down.
// // To re-enable later: set ENABLE_SOCKET_IO = true (or uncomment the old `io(REST_API_IO, ...)` code kept in each file).
// export const ENABLE_SOCKET_IO = false;
// export const COMPANY_NAME = user?.company_name || 'Signwise Solutions Riverside Dev'
// export const currentFacilityId = 8
// export const FacilityTypes = [ // make true for current facility
//   { id: 1, label: 'Arizona', code: 'AZ',default:false,color:"primary" },
//   { id: 2, label: 'Riverside', code: 'RIV',default:false,color:"warning" },
//   { id: 3, label: 'LA', code: 'LA',default:false,color:"success" },
//   // { id: 4, label: 'Dev', code: 'DEV',default:true,color:"success" },
//   // { id: 5, label: 'Training', code: 'TRAINING',default:true,color:"error" },
//   { id: 6, label: 'NCA', code: 'NCA',default:false,color:"error" },
//   { id: 7, label: 'Dev-AZ', code: 'DEV-AZ',default:false,color:"success" },
//   { id: 8, label: 'Dev-RIV', code: 'DEV-RIV',default:true,color:"success" },
// ]

//training.signwisesolutions.com/
// export const BASE_URL = "https://training.signwisesolutions.com/"
// export const REST_API_END_POINT = "https://training.signwisesolutions.com/backend/webservice/";
// export const REST_API = "https://training.signwisesolutions.com/backend/";
// export const REST_API_IO = "https://socket.signwisesolutions.com";
// export const BASE_URL_QR = "https://training.signwisesolutions.com"
// export const DOMAIN = 'training';
// export const QBShow = false;
// export const ENABLE_NEW_RELIC = false;
// // Socket IO disabled to stop console WebSocket errors when socket.signwisesolutions.com is down.
// // To re-enable later: set ENABLE_SOCKET_IO = true (or uncomment the old `io(REST_API_IO, ...)` code kept in each file).
// export const ENABLE_SOCKET_IO = false;
// export const COMPANY_NAME = user?.company_name || 'Signwise Solutions Training'
// export const currentFacilityId = 5
// export const FacilityTypes = [ // make true for current facility
//   { id: 1, label: 'Arizona', code: 'AZ',default:false,color:"primary" },
//   { id: 2, label: 'Riverside', code: 'RIV',default:false,color:"warning" },
//   { id: 3, label: 'LA', code: 'LA',default:false,color:"success" },
//   // { id: 4, label: 'Dev', code: 'DEV',default:true,color:"success" },
//   { id: 5, label: 'Training', code: 'TRAINING',default:true,color:"error" },
// ]

// ok.signwisesolutions.com/
// export const BASE_URL = "https://ok.signwise3s.com/"
// export const REST_API_END_POINT = "https://ok.signwise3s.com/backend/webservice/";
// export const REST_API = "https://ok.signwise3s.com/backend/";
// export const REST_API_IO = "https://socket.signwise3s.com";
// export const BASE_URL_QR = "https://ok.signwise3s.com"
// export const DOMAIN = 'ok';
// export const QBShow = false;
// export const ENABLE_NEW_RELIC = false;
// // Socket IO disabled to stop console WebSocket errors when socket.signwisesolutions.com is down.
// // To re-enable later: set ENABLE_SOCKET_IO = true (or uncomment the old `io(REST_API_IO, ...)` code kept in each file).
// export const ENABLE_SOCKET_IO = false;
// export const COMPANY_NAME = user?.company_name || 'Signwise Solutions Oklahoma'
// export const currentFacilityId = 10
// export const FacilityTypes = [ // make true for current facility
//   { id: 1, label: 'Arizona', code: 'AZ',default:false,color:"primary" },
//   { id: 2, label: 'Riverside', code: 'RIV',default:false,color:"warning" },
//   { id: 3, label: 'LA', code: 'LA',default:false,color:"success" },
//   // { id: 4, label: 'Dev', code: 'DEV',default:true,color:"success" },
//   // { id: 5, label: 'Training', code: 'TRAINING',default:true,color:"error" },
//   { id: 6, label: 'NCA', code: 'NCA',default:false,color:"error" },
//   { id: 7, label: 'LV', code: 'LV',default:false,color:"info" },
//   { id: 8, label: 'DEN', code: 'DEN',default:false,color:"secondary" },
//   { id: 9, label: 'COS', code: 'COS',default:false,color:"primary" },
//   { id: 10, label: 'OK', code: 'OK',default:true,color:"success" }
// ]

// //manteca.signwisesolutions.com/
// export const BASE_URL = "https://manteca.signwisesolutions.com/"
// export const REST_API_END_POINT = "https://manteca.signwisesolutions.com/backend/webservice/";
// export const REST_API = "https://manteca.signwisesolutions.com/backend/";
// export const REST_API_IO = "https://socket.signwisesolutions.com";
// export const BASE_URL_QR = "https://manteca.signwisesolutions.com"
// export const DOMAIN = 'manteca';
// export const QBShow = false;
// export const ENABLE_NEW_RELIC = false;
// // Socket IO disabled to stop console WebSocket errors when socket.signwisesolutions.com is down.
// // To re-enable later: set ENABLE_SOCKET_IO = true (or uncomment the old `io(REST_API_IO, ...)` code kept in each file).
// export const ENABLE_SOCKET_IO = false;

// wiseai.signwisesolutions.com
// export const BASE_URL = "https://wiseai.signwisesolutions.com/"
// export const REST_API_END_POINT = "https://wiseai.signwisesolutions.com/backend/webservice/";
// export const REST_API = "https://wiseai.signwisesolutions.com/backend/";
// export const REST_API_IO = "https://socket.signwisesolutions.com";
// export const BASE_URL_QR = "https://wiseai.signwisesolutions.com"
// export const DOMAIN = 'wiseai';
// export const QBShow = false;
// // Socket IO disabled to stop console WebSocket errors when socket.signwisesolutions.com is down.
// // To re-enable later: set ENABLE_SOCKET_IO = true (or uncomment the old `io(REST_API_IO, ...)` code kept in each file).
// export const ENABLE_SOCKET_IO = false;

// my.signwisesolutions.com
// export const REST_API_END_POINT = "https://api.signwisesolutions.skyniche.website/webservice/";
// export const REST_API = "https://api.signwisesolutions.skyniche.website/";
// export const REST_API_IO = "https://socket.signwisesolutions.com";
// export const BASE_URL = "https://my.signwisesolutions.com/";
// export const BASE_URL_QR = "https://my.signwisesolutions.com"
// export const DOMAIN = 'my';
// export const QBShow = false;

export const COMPANY_LOGO = user?.company_logo || Logo

export const PUBNUB_PUBLISH_KEY= 'pub-c-014b4ee8-2c24-46d0-ae01-4a933c3fee2e'
export const PUBNUB_SUBSCRIBE_KEY= 'sub-c-53f81de7-6961-4d0e-87bb-f3defdef49a0'
export const PUBNUB_SECRET_KEY="sec-c-NTY0NDYwZDEtN2M3MC00Y2YwLWE4ZmItMzdmMjc5MTY1YTNl"

export const TICKET_PREFIX = (DOMAIN == 'arizona') ? 'AZ-' : (DOMAIN == 'riv') ? 'RIV-' : (DOMAIN == 'la') ? 'LA-' : (DOMAIN == 'nca') ? 'NCA-' : 'SW-'

// export const UNITS = [
//     { id: 1, name: 'Square feet', short_name: 'Sq ft', unit_id: 1 },
//     { id: 2, name: 'Linear feet', short_name: 'Lin ft', unit_id: 1 },
//     { id: 3, name: 'Square inches', short_name: 'Sq in', unit_id: 1 },
//     { id: 4, name: 'Unit', short_name: 'Unit', unit_id: 2 },
//     { id: 5, name: 'Gallons', short_name: 'Gal', unit_id: 3 },
//     { id: 6, name: 'Quarts', short_name: 'Qt', unit_id: 3 },
//     { id: 7, name: 'Milliliter', short_name: 'ml', unit_id: 3 },
//     { id: 8, name: 'Ounce', short_name: 'oz', unit_id: 3 },
//     { id: 9, name: 'Kilogram', short_name: 'kg', unit_id: 4 },
//     { id: 10, name: 'Gram', short_name: 'g', unit_id: 4 },
//     { id: 11, name: 'Milligram', short_name: 'mg', unit_id: 4 },
// ];

export const UNITS = [
  { id: 1, name: 'Square feet', short_name: 'Sq ft', unit_id: 1 },
  { id: 2, name: 'Linear feet', short_name: 'Lin ft', unit_id: 1 },
  { id: 3, name: 'Square inches', short_name: 'Sq in', unit_id: 1 },
  { id: 16, name: 'Yards', short_name: 'yd', unit_id: 1 },
  { id: 4, name: 'Unit', short_name: 'Unit', unit_id: 2 },
  { id: 5, name: 'Gallons', short_name: 'Gal', unit_id: 3 },
  { id: 6, name: 'Quarts', short_name: 'Qt', unit_id: 3 },
  { id: 7, name: 'Milliliter', short_name: 'ml', unit_id: 3 },
  { id: 8, name: 'Liter', short_name: 'L', unit_id: 3 },
  { id: 9, name: 'Pint', short_name: 'pt', unit_id: 3 },
  { id: 10, name: 'Half Pint', short_name: 'half-pt', unit_id: 3 },
  { id: 11, name: 'Ounce', short_name: 'oz', unit_id: 3 },
  { id: 12, name: 'Kilogram', short_name: 'kg', unit_id: 4 },
  { id: 13, name: 'Gram', short_name: 'g', unit_id: 4 },
  { id: 14, name: 'Milligram', short_name: 'mg', unit_id: 4 },
  { id: 15, name: 'Each', short_name: 'EA', unit_id: 2 },
];

export const MATERIALTYPES = [
    { id: 1, name: 'Inventory', },
    { id: 2, name: 'Non-Inventory', },
    { id: 3, name: 'Services', },
    // { id: 4, name: 'Buldle', },
]

//For messenger chat
export const STATUS_OPTIONS = [
  { id: 1, statusData: 'online', label: 'Available' },
  { id: 2, statusData: 'away', label: 'Away' },
  { id: 3, statusData: 'busy', label: 'Busy' },
  { id: 4, statusData: 'invisible', label: 'Invisible' },
  { id: 5, statusData: 'dnd', label: 'Do not disturb' },
];

export const filteredOtherFacilityTypes = FacilityTypes.filter(facility => facility.id !== currentFacilityId)

// export const currentFacilityName = 'Arizona'
// export const currentFacilityName = 'Riverside'
// export const currentFacilityName = 'LA'